import Vue from 'vue'

let client = () => Vue.prototype.$api

export default {
    getPreviousMonthsResults (testId, patientId = null) {
        return client().get(`/patients/self-evaluation-tests/${testId}`, {params: {patientId: patientId}})
    },
    getMenstruations () {
        return client().get('/patients/menstruations')
    },
    postMenstruation(cycleData) {
        return client().post('/patients/menstruations', cycleData)
    },
    deleteMenstruation(cycleId) {
        return client().delete(`/patients/menstruations/${cycleId}`);
    },
    putMenstruation(updatedCycleData) {
        return client().put('/patients/menstruations', updatedCycleData)
    },
    fillSelfEvaluationTest (form) {
        return client().post('/patients/self-evaluation-tests', form)
    },
    getAssociatedPatients () {
        return client().get('/patients/associated-patients')
    },
    updatePatientPersonalData (fields, userId) {
        return client().put('/PatientPersonalDataController', {'idAspNetUser': userId, ...fields})
    },
    GetLastCompletedFromEachTest (patientId) {
        return client().get('/patients/self-evaluation-tests/last-completed-from-each-test', {params: {patientId: patientId}})
    },
    updatePatient (updateRequest) {
        return client().put('/patients', updateRequest)
    },
    getAssociatedPatientsForRequest () {
        return client().get('/patients/associated-patients/GetAssociatedPatientsForRequest')
    },
    getPatientInfo () {
        return client().get('/patients/GetPatientInfo')
    },
    toggleFavouriteDoctor (profId) {
        return client().put('/FavouriteProfessionals/ToggleFavourite', null, { params: { profId: profId }})
    },
    getPatientById (id) {
        return client.get(`/patients/${id}`)
    }
}


// WEBPACK FOOTER //
// ./src/repositories/PatientsRepository.js